import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {storeAddEditTimingReady} from '../redux/stores'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'



import TimePicker from 'react-time-picker'

import CollapsibleRow from './CollapsibleRow'

//import * as Helpers from '../../../common/helpers'

//var TimePicker = require('basic-react-timepicker');

function filterUnwantedData(storesData) {
    let array = []
    if (storesData && storesData.data) {
        array = storesData.data
    }

    
            let newLineData = {}
            let lineData = array
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.store_name = lineData.name ? lineData.name : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"
            newLineData.kitchen_name =lineData.kitchen.name ? lineData.kitchen.name : "NA"
            newLineData.brand_name =lineData.brand.name ? lineData.brand.name : "NA"
            newLineData.urbanpiper_id =lineData.urbanpiper_id ? lineData.urbanpiper_id : "NA"


            let store_timings = []
            
            for (let j = 0; j < lineData.store_timings.length; j++) {
                let end_day=false;
                if(lineData.store_timings[j].end_day==="NEXT_DAY"){
                    end_day=true;
                }

                store_timings[j]={
                    "store_timings_id":lineData.store_timings[j].id,
                    "store_id":lineData.id,
                    "start_time":lineData.store_timings[j].start_time,
                    "end_time":lineData.store_timings[j].end_time,
                    "end_day":end_day
                    }                    
            }   
            newLineData.store_timings=store_timings;


    return newLineData
}




class AddEditStoreTiming extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",
            clearIcon:null,
            
            selectedStoreId: "",
            storeData:{}
           
         }

         this.startTimevalue="10:00";
         this.endTimevalue="11:00";

       
    }

    componentWillMount() {
        this.isComponentStillMounted = true
        //this.props.dispatch(storeAddEditTimingReady(true))
        
        if(this.props.stores && this.props.stores.storeSelectedId && this.props.stores.storeSelectedId !== null){
            this.setState({subTitle: Constants.ADD_EDIT_STORE_TIMING})
            this.props.dispatch(headerDataUpdate(Constants.ADD_EDIT_STORE_TIMING)) 
            this.props.dispatch(subHeaderDataUpdate())
            this.setState({
                selectedStoreId: this.props.stores.storeSelectedId
            });

            this.getStoreDetailsById()
        }else{
            this.props.history.goBack()
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    componentDidMount() {

    }


    getStoreDetailsById=()=>{
        this.props.dispatch(storeAddEditTimingReady(false))
       
            apiService.getStoreDetailsById(this.props.stores.storeSelectedId)
                .then(responseData => {
                    this.props.dispatch(storeAddEditTimingReady(true))
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {
                        let data=filterUnwantedData(responseData)
                        this.setState({
                            storeData:data
                        })
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(storeAddEditTimingReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Product creation got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
    }


    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 130) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 120) + "px",
            })
        }
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    onSaveClick = () => {
        this.props.dispatch(storeAddEditTimingReady(false))
        //let data ={}

        let checkedValue = document.getElementById("checkbox_id").checked;

        if(this.startTimevalue==='' || this.startTimevalue===undefined || this.startTimevalue===null){
            this.props.dispatch(storeAddEditTimingReady(true))
            this.dialog.show({
                            title: "Error!!",
                            body: "Please provide start time in 24 hours format",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(this.endTimevalue==='' || this.endTimevalue===undefined || this.endTimevalue===null){
            this.props.dispatch(storeAddEditTimingReady(true))
             this.dialog.show({
                            title: "Error!!",
                            body: "Please provide end time in 24 hours format",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(parseInt(this.startTimevalue.split(":").join(""),10)<0 || parseInt(this.startTimevalue.split(":").join(""),10)>=2400){
            this.props.dispatch(storeAddEditTimingReady(true))
            alert("Start time should fall  in between 00 to 24 Hrs");
            return false
        }


        if(parseInt(this.endTimevalue.split(":").join(""),10)<0 || parseInt(this.endTimevalue.split(":").join(""),10)>=2400){
            this.props.dispatch(storeAddEditTimingReady(true))
           this.dialog.show({
                            title: "Error!!",
                            body: "End time should fall in between 00 to 24 Hrs",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }


        if(parseInt(this.endTimevalue.split(":").join(""),10)-parseInt(this.startTimevalue.split(":").join(""),10)<60 && !checkedValue){
             this.props.dispatch(storeAddEditTimingReady(true))
                        this.dialog.show({
                            title: "Error!!",
                            body: "Start and end time should have minimum 1 hour range",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

           

        let enday="CURRENT_DAY"

        if(checkedValue){
            enday="NEXT_DAY"
        }

        let apiPayloadData={
                "start_time": this.startTimevalue,
                "end_time": this.endTimevalue,
                "store_id": this.state.selectedStoreId,
                "end_day": enday
            }

            this.checkOverLapTiming(apiPayloadData)


    }

    overLappingMsg=(overLappingTimes)=>{

            this.props.dispatch(storeAddEditTimingReady(true))
                        this.dialog.show({
                            title: "Error!!",
                            body: "Given time is overlapping with existing time slots ( "+overLappingTimes+" ). Please check and use other time range",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
    }



    callAPICall=(apiPayloadData)=>{

          apiService.addStoreTiming(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(storeAddEditTimingReady(true))
                        //this.props.history.goBack()
                        window.location.reload();
                    } else {

                        this.props.dispatch(storeAddEditTimingReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(storeAddEditTimingReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
    }

    checkOverLapTiming=(apiPayloadData)=>{

        let startime=parseInt(apiPayloadData.start_time.split(":").join(""),10)
        let endtime=parseInt(apiPayloadData.end_time.split(":").join(""),10)

        
        apiService.getStoreDetailsById(this.state.selectedStoreId)
            .then(responseData => {
                    let store_timings=responseData.data.store_timings;
                    if(store_timings.length===0){
                        this.callAPICall(apiPayloadData)
                    }else{
                        let overLappingflag=false;
                        let overLappingTimes="";
                        for (var i = store_timings.length - 1; i >= 0; i--) {
                            let api_start_time=parseInt(store_timings[i]['start_time'].split(":").join(""),10)
                            let api_end_time=parseInt(store_timings[i]['end_time'].split(":").join(""),10)
                            let end_day=store_timings[i]['end_day']

                            if(end_day==="CURRENT_DAY" && apiPayloadData.end_day==="CURRENT_DAY"){

                                if((startime>=api_start_time && startime<=api_end_time) || (endtime>=api_start_time && endtime<=api_end_time)){
                                    overLappingflag=true;
                                    overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                }

                            }else if(end_day==="NEXT_DAY" && apiPayloadData.end_day==="CURRENT_DAY"){

                                if((startime>=api_start_time && startime<=2359) || (endtime>=api_start_time && endtime<=2359) || (startime>=0 && startime<=api_end_time) || (endtime>=0 && endtime<=api_end_time)){
                                    overLappingflag=true;
                                    overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                }

                            }else if(end_day==="CURRENT_DAY" && apiPayloadData.end_day==="NEXT_DAY"){

                                if((startime<=api_start_time && 2359>=api_start_time) || (startime<=api_end_time && 2359>=api_end_time) || (0<=api_start_time && 0>=api_start_time) || (endtime<=api_end_time && endtime>=api_end_time)){
                                    overLappingflag=true;
                                    overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                }

                            }else if(end_day==="NEXT_DAY" && apiPayloadData.end_day==="NEXT_DAY"){

                                if((startime>=api_start_time && startime<=2359) || (endtime>=api_start_time && endtime<=2359) || (startime>=0 && startime<=api_end_time) || (endtime>=0 && endtime<=api_end_time) || (startime<=api_start_time && 2359>=api_start_time) || (startime<=api_end_time && 2359>=api_end_time) || (0<=api_start_time && 0>=api_start_time) || (endtime<=api_end_time && endtime>=api_end_time)){
                                    overLappingflag=true;
                                    overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                }

                                }
                            }
                            if(overLappingflag){
                                this.overLappingMsg(overLappingTimes)
                            }else{
                                this.callAPICall(apiPayloadData);
                            }
                        }
            })
            .catch(err => {
                this.props.dispatch(storeAddEditTimingReady(true))
                console.error("Error data: ", err)
                alert("exception"+ err);
            })
    }

    startTimeChange= (value,e) => {
        this.startTimevalue=value;
    }

    endTimeChange= (value,e) => {        
        this.endTimevalue=value;
    }

   

   
    onCancelClick = () => {
        this.props.history.goBack()
    }
    
    render() {
        return (
            <div className="line-item-edit">
   <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
   <a href="" 
      onClick={(e) => {e.preventDefault() 
   this.props.history.goBack()}}> 
   <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
   </a>
</div>
<Dialog ref={el =>
this.dialog = el} />
<section className="content">
   <div className="row">
      <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
         <div className="box box-info" style={{ borderTop: "0px" }}>                                
         <div className="form-horizontal">
            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
            <div className="box box-info" style={{ borderTop: "0px" }}>
            <div className="box-header with-border">
               <h3 className="box-title" style={{ fontWeight: 600 }}>Store Details</h3>
            </div>
            <div className="form-horizontal">
               <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
               <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="col-md-6 col-sm-12 col-xs-12">
                     <div className="form-group">
                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Store:</label>
                        <div className="col-sm-9">
                           {(() => {
                           if(this.state.storeData.store_name && this.state.storeData.store_name!=="" && this.state.storeData.store_name!==undefined){
                           return(
                           <p>{this.state.storeData.store_name}</p>
                           )
                           }else{
                           return(
                           <p>NA</p>
                           )
                           }
                           })()}                                         
                        </div>
                     </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12">
                     <div className="form-group">
                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status:</label>
                        <div className="col-sm-9">
                           {(() => {
                           if(this.state.storeData.status && this.state.storeData.status!=="" && this.state.storeData.status!==undefined){
                           return(
                           <p>{this.state.storeData.status}</p>
                           )
                           }else{
                           return(
                           <p>NA</p>
                           )
                           }
                           })()}                                         
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="col-md-6 col-sm-12 col-xs-12">
                     <div className="form-group">
                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen:</label>
                        <div className="col-sm-9">
                           {(() => {
                           if(this.state.storeData.kitchen_name && this.state.storeData.kitchen_name!=="" && this.state.storeData.kitchen_name!==undefined){
                           return(
                           <p>{this.state.storeData.kitchen_name}</p>
                           )
                           }else{
                           return(
                           <p>NA</p>
                           )
                           }
                           })()}                                         
                        </div>
                     </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12">
                     <div className="form-group">
                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Brand:</label>
                        <div className="col-sm-9">
                           {(() => {
                           if(this.state.storeData.brand_name && this.state.storeData.brand_name!=="" && this.state.storeData.brand_name!==undefined){
                           return(
                           <p>{this.state.storeData.brand_name}</p>
                           )
                           }else{
                           return(
                           <p>NA</p>
                           )
                           }
                           })()}                                         
                        </div>
                     </div>
                  </div>
               </div>
               {(() => {
               if(this.state.storeData.store_timings && this.state.storeData.store_timings.length>0){
               return(
               <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="box-header with-border">
                     <h3 className="box-title" style={{ fontWeight: 600 }}>Store Timings</h3>
                  </div>
                  <br/>
                  <CollapsibleRow row={this.state.storeData} />
               </div>
               )
               }
               })()}     
            </div>
         </div>
      </div>
      <div className="box box-info" style={{ borderTop: "0px" }}>
      <div className="box-header with-border">
         <h3 className="box-title" style={{ fontWeight: 600 }}>Add New Timing</h3>
      </div>
      <div className="form-horizontal">
         <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>   
         <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="col-md-6 col-sm-12 col-xs-12">
               <div className="form-group">
                  <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "9px"}}>Start Time *</label>
                  <div className="col-sm-9" >
                     <TimePicker clearIcon={this.state.clearIcon} format="H:mm"
                        onChange={(value, e) =>
                     this.startTimeChange(value, e)}
                     value={this.startTimevalue} className="react-time-picker" disableClock="false"/>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="col-md-6 col-sm-12 col-xs-12">
               <div className="form-group">
                  <label className="col-sm-3 control-label labels"  style={{textAlign: "right", paddingTop: "9px"}}>End Time *</label>
                  <div className="col-sm-9" >
                     <TimePicker clearIcon={this.state.clearIcon} format="H:mm" className="react-time-picker" 
                        onChange={(value, e) =>
                     this.endTimeChange(value, e)} value={this.endTimevalue} disableClock="false"/>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="col-md-6 col-sm-12 col-xs-12">
               <div className="form-group" style={{"marginLeft":"26%"}}>
                  <input className="checkbox" type="checkbox" name="checkbox" id="checkbox_id" value="value" style={{"float": "left"}}/>
                  <label for="checkbox_id" style={{"float": "left","margin": "4px 6px"}}>Next Day</label>
               </div>
            </div>
         </div>
         <div className="col-md-12 col-sm-12 col-xs-12">
            <span><b>Notes:</b></span>
            <ul>
               <li>Please use 24-Hours format.</li>
               <li>Day starts with 00:00 and ends with 23:59</li>
               <li>If end time falls under next day window, please check <strong>Next Day</strong> checkbox</li>
            </ul>
         </div>
      </div>
   </div>
   </div>
   </div>
   <div className="box-footer">
      <button
         className="btn btn-default"
         onClick={(e) => {
      e.preventDefault()
      this.onCancelClick()
      }}>
      Cancel
      </button>
      <button
         className="btn btn-info pull-right"
         onClick={(e) => {
      e.preventDefault()
      this.onSaveClick()
      }}>
      Add New Timing
      </button>
   </div>
   </div>
   </div>
   </div>
   </div>
</section>
</div>
        )
    }

}
function mapStateToProps(state) {
    return {
        stores: state.stores,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditStoreTiming))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/AddEditStoreTiming.js